var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d82b6d87fdd181ec6ee1e4345492864ce891acbd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@playback-inc"]={id:"d82b6d87fdd181ec6ee1e4345492864ce891acbd"};
      